import { Dispatch } from 'redux';
import { setExternalLinkState } from '../ducks/app-context';
import { ExternalLinkState } from '../models/app-context-model';
import { EcdRoutes } from '../constants/routes';

export function addQueryParams(baseUrl: string, queryParams: Object) {
    const populatedParams = Object.keys(queryParams).filter(key => !!queryParams[key]);

    return populatedParams.reduce((str, key, index) => {
        return `${str}${index > 0 ? '&' : '?'}${key}=${queryParams[key]}`;
    }, baseUrl);
}

export function handleExternalLinkClick(e: React.MouseEvent<HTMLElement>,
    dispatch: Dispatch<any>,
    history: any,
    location: any,        
) {
    const targetLink = (e.target as HTMLElement)?.closest('a') as HTMLAnchorElement;
    const isExternal = !targetLink?.href?.includes(window.location.host);
    
    const isLocationLocal = location?.pathname?.includes(window.location.host);
    const isECDLink = targetLink?.href?.includes(`${window.location.host}/${EcdRoutes.ECDRoot}`);
    
    if (!targetLink || (!isExternal && !isECDLink)) return;

    e.preventDefault();

    if (isExternal) {
        const externalLinkState: ExternalLinkState = {
            renderModal: true,
            linkUrl: targetLink.href,
            linkInnerHtml: targetLink.innerHTML,
        };

        dispatch(setExternalLinkState(externalLinkState));
    } else if (isLocationLocal && isECDLink) {
        history.push(targetLink.pathname);
    } 
}